import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { MinusIcon, PlusIcon } from 'lucide-react';
import { faqs } from '../data/content';
export function Faq() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section aria-labelledby="faq-heading" className="border-t border-navy-700 bg-navy" data-id="element-98" data-mp="1l9fsrdjruo8y">
      <div className="mx-auto max-w-page px-4 py-12 sm:px-5 lg:py-24" data-id="element-99" data-mp="1gal07jw05lbn">
        <div className="grid gap-7 lg:grid-cols-[0.7fr_1.3fr] lg:gap-20" data-id="element-100" data-mp="2dz4wvzrs34es">
          <h2 id="faq-heading" className="font-display text-2xl font-extrabold leading-[1.08] tracking-[-0.03em] text-white sm:text-4xl" data-id="element-101" data-mp="2913d1cmj3129">
            Questions, answered
          </h2>

          <dl className="border-t border-navy-700" data-id="element-102" data-mp="1z2dsfc38z2ib">
            {faqs.map((faq, index) => {
            const isOpen = openIndex === index;
            return <div key={faq.question} className="border-b border-navy-700" data-id="element-103" data-mp="nniha03t7j6i" data-mpi={index}>
                  <dt data-id="element-104" data-mp="phy1bk0oa1tw">
                    <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} className="group flex w-full items-center justify-between gap-6 py-5 text-left focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gold" data-id="element-105" data-mp="phelq9yhvpj1">
                      <span className="font-display text-[17px] font-bold text-white transition-colors duration-150 ease-smooth group-hover:text-gold" data-id="element-106" data-mp="6qf09iq7kxui">
                        {faq.question}
                      </span>
                      {isOpen ? <MinusIcon className="h-4 w-4 shrink-0 text-gold" aria-hidden="true" data-id="element-107" data-mp="3swtqavo3t6ws" /> : <PlusIcon className="h-4 w-4 shrink-0 text-steel" aria-hidden="true" data-id="element-108" data-mp="3jxgevxgf689f" />}
                    </button>
                  </dt>
                  <AnimatePresence initial={false} data-id="element-109" data-mp="3o1eee99npl30">
                    {isOpen && <motion.dd initial={{
                  height: 0,
                  opacity: 0
                }} animate={{
                  height: 'auto',
                  opacity: 1
                }} exit={{
                  height: 0,
                  opacity: 0
                }} transition={{
                  duration: 0.2,
                  ease: [0.23, 1, 0.32, 1]
                }} className="overflow-hidden" data-id="element-110" data-mp="1ui5t63xa9xld">
                        <p className="max-w-2xl pb-5 text-[15px] leading-relaxed text-mist" data-id="element-111" data-mp="2dedzlb218ei9">
                          {faq.answer}
                        </p>
                      </motion.dd>}
                  </AnimatePresence>
                </div>;
          })}
          </dl>
        </div>
      </div>
    </section>;
}